import {productSectionServiceProxy} from '../servicePool';

export function getProducSections() {
  return productSectionServiceProxy.getProducSections();
}
